import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export function FacebookReviews() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const reviewImages = ['https://uploadthingy.s3.us-west-1.amazonaws.com/rSRuTMhNExLFpVPJDFkLn4/Untitled_design_%2813%29_converted.webp', 'https://uploadthingy.s3.us-west-1.amazonaws.com/41BT59EQityAtnr4ZrKq3p/Untitled_design_%2814%29_converted.webp', 'https://uploadthingy.s3.us-west-1.amazonaws.com/deqRS4qWH9XyyXfcuHgjFX/Untitled_design_%2815%29_converted.webp', 'https://uploadthingy.s3.us-west-1.amazonaws.com/kSKCDVAFVoUtL2JhJB3WHc/Untitled_design_%2816%29_converted.webp', 'https://uploadthingy.s3.us-west-1.amazonaws.com/ucosr1P8mGuZu89y7iZyLw/Untitled_design_%2817%29_converted.webp'];
  const nextSlide = () => {
    setCurrentIndex(prev => (prev + 1) % reviewImages.length);
  };
  const prevSlide = () => {
    setCurrentIndex(prev => (prev - 1 + reviewImages.length) % reviewImages.length);
  };
  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };
  return <div className="my-16" data-id="element-210">
      

      {/* Carousel Container */}
      <div className="relative max-w-3xl mx-auto" data-id="element-211">
        {/* Main Image Display */}
        <div className="relative bg-white rounded-xl shadow-2xl overflow-hidden" data-id="element-212">
          <img src={reviewImages[currentIndex]} alt={`Customer review ${currentIndex + 1}`} className="w-full h-auto" data-id="element-213" />

          {/* Navigation Arrows */}
          <button onClick={prevSlide} className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 rounded-full p-2 shadow-lg transition-all duration-200 hover:scale-110" aria-label="Previous review" data-id="element-214">
            <ChevronLeftIcon className="w-6 h-6" data-id="element-215" />
          </button>

          <button onClick={nextSlide} className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 rounded-full p-2 shadow-lg transition-all duration-200 hover:scale-110" aria-label="Next review" data-id="element-216">
            <ChevronRightIcon className="w-6 h-6" data-id="element-217" />
          </button>
        </div>

        {/* Dots Navigation */}
        <div className="flex justify-center gap-2 mt-6" data-id="element-218">
          {reviewImages.map((_, index) => <button key={index} onClick={() => goToSlide(index)} className={`transition-all duration-300 rounded-full ${index === currentIndex ? 'w-8 h-3 bg-purple-600' : 'w-3 h-3 bg-gray-300 hover:bg-gray-400'}`} aria-label={`Go to review ${index + 1}`} data-id="element-219" />)}
        </div>
      </div>

      {/* Trust badge */}
      <div className="mt-8 text-center" data-id="element-220">
        <div className="inline-flex items-center gap-2 bg-green-50 border-2 border-green-200 rounded-full px-6 py-3" data-id="element-221">
          <svg className="w-6 h-6 text-green-600" fill="currentColor" viewBox="0 0 20 20" data-id="element-222">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-223" />
          </svg>
          <span className="font-bold text-green-800" data-id="element-224">
            Verified Customer Reviews
          </span>
        </div>
      </div>
    </div>;
}